import { COLORS } from '@avalara/bat-apps-shared/constants';
import styled from 'styled-components';

export const LightGreyBox = styled.div`
  background-color: ${COLORS.grayLightest};
`;

export const LightGreyRoundedBox = styled(LightGreyBox)`
  border-radius: 4px;
`;
